/**
 * LocalStorage utility functions for authentication and data persistence
 */

const USER_SLUG_KEY = 'user-slug';

/**
 * Store user slug in localStorage
 */
export function storeSlug(slug: string): void {
  try {
    localStorage.setItem(USER_SLUG_KEY, slug);
  } catch (error) {
    console.error('Failed to store slug in localStorage:', error);
  }
}

/**
 * Get stored user slug from localStorage
 */
export function getStoredSlug(): string | null {
  try {
    return localStorage.getItem(USER_SLUG_KEY);
  } catch (error) {
    console.error('Failed to get slug from localStorage:', error);
    return null;
  }
}

/**
 * Remove user slug from localStorage (logout)
 */
export function removeSlug(): void {
  try {
    localStorage.removeItem(USER_SLUG_KEY);
  } catch (error) {
    console.error('Failed to remove slug from localStorage:', error);
  }
}

/**
 * Check if user is authenticated (has stored slug)
 */
export function isAuthenticated(): boolean {
  return getStoredSlug() !== null;
}

/**
 * Clear all localStorage data
 */
export function clearStorage(): void {
  try {
    localStorage.clear();
  } catch (error) {
    console.error('Failed to clear localStorage:', error);
  }
}
